import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { Box, Button, Text } from "@noom/wax-component-library";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { InformationalScreen } from "@/components/survey/questionTypes/core";
import { ProgramEligibilityFooter } from "@/components/survey/questionTypes/dpp-triage";

const QUESTION_ID = "nonMedEligible";

const NonMedEligible: React.FC<QuestionComponentProps> = ({ onClickNext }) => {
  const { t } = useTranslation();

  return (
    <InformationalScreen
      heading={<Trans i18nKey="nonMedEligible.title" />}
      questionId={QUESTION_ID}
    >
      <Text color="white" fontSize="18px" lineHeight="26px">
        <Trans i18nKey="nonMedEligible.message" />
      </Text>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop="var(--spacing-xl)"
      >
        <Button
          colorScheme="primary"
          onClick={() => onClickNext(null)}
          padding="unset"
          size="xl"
          whiteSpace="unset"
        >
          {t("nonMedEligible.ctaText")}
        </Button>
      </Box>
      <Box marginTop="var(--spacing-xl)">
        <ProgramEligibilityFooter />
      </Box>
    </InformationalScreen>
  );
};

export const Q_NON_MED_ELIGIBLE: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: ({ qualifiedPrograms, surveyAnswers }) =>
    surveyAnswers.glp1Weight !== undefined &&
    !qualifiedPrograms.includes("MED"),
  component: NonMedEligible,
};
